export const withdrawlReasonsData = [
	{
		id: 1,
		withdrawlReason: '찾는 상품이 없어요.',
	},
	{
		id: 2,
		withdrawlReason: '등록한 상품이 안팔려요.',
	},
	{
		id: 3,
		withdrawlReason: '비매너 사용자를 만났어요.',
	},
	{
		id: 4,
		withdrawlReason: '잘 사용하지 않아요.',
	},
	{
		id: 5,
		withdrawlReason: '서비스가 불편해요.',
	},
	{
		id: 6,
		withdrawlReason: '새로운 계정으로 가입하고 싶어요.',
	},
	{
		id: 7,
		withdrawlReason: '기타',
	},
];
